import * as React from 'react'
export const Pe = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 85.331h512v341.326H0z" />
    <path fill="#D80027" d="M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z" />
  </svg>
)
